export default "__VITE_ASSET__BMe56jzk__"